{
  "colorFormat": "تنسيق اللون",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
